import { IsOptional, IsString } from "class-validator";
import { Interface } from "../../types";

export class MeteredCheckoutRequest {
  constructor(data?: Interface<MeteredCheckoutRequest>) {
    if (data) {
      Object.assign(this, data);
    }
  }

  /** Optional for backwards compatibility. */
  @IsOptional()
  @IsString()
  deviceId?: string;
}
